export default function (validacaoNumeroLivroFolha, orgaosExpedidores, validaCpfCnpj, siglasEstados, gentilicos, estadoCivil, finalidade, faixaFronteira) {
  return {
    NAO_ONEROSO: {
      groups: [
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          styleClasses: 'none',
          fields: [
            {
              column: 12,
              type: 'elementInput',
              model: 'especie',
              inputName: 'especie',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Espécie: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'portaria.numeroSei',
              inputName: 'numeroSei',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº SEI: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementDatePicker',
              model: 'dataNascimentoOutorgado',
              inputName: 'dataNascimentoOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              editable: false,
              clearable: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Nascimento: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date',
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'profissao',
              inputName: 'profissao',
              visible: true,
              required: true,
              disabled: true,
              readonly: false,
              inputType: 'text',
              validator: 'required',
              elementLabel: 'Profissão: ',
              visiblePf: (model) => model.profissao,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: estadoCivil,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: orgaosExpedidores(),
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: (model) => model.orgaoExpedidorOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              visiblePf: (model) => model.ufRgOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: (model) => model.rgOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 8,
              type: 'elementDatePicker',
              model: 'dataNascimentoConjuge',
              inputName: 'dataNascimentoConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              editable: false,
              clearable: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Nascimento: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: '
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: orgaosExpedidores(),
              filterable: false,
              elementLabel: 'Orgão expedidor: '
            }
          ]
        },
        {
          legend: '04 - FUNDAMENTAÇÃO ESTADUAL',
          codigo: 'FUNDAMENTACAO_ESTADUAL',
          styleClasses: 'none',
          fields: [
            {
              column: 12,
              type: 'elementInput',
              model: 'comarca',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              validator: 'required',
              elementLabel: 'Comarca: ',
              clearable: true
            }
          ]
        },
        {
          legend: '05 - CARACTERÍSTICAS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 8,
              type: 'elementInput',
              model: 'portaria.denominacao',
              inputName: 'input_name',
              visible: (model) => model.portaria.denominacao,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Denominação do Imóvel: ',
              clearable: true
            },
            {
              column: 16,
              type: 'elementInput',
              model: 'portaria.localizacao',
              inputName: 'input_name',
              visible: (model) => model.portaria.localizacao,
              disabled: true,
              required: true,
              readonly: false,
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Comunidade: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'portaria.areaLiquida',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Área (HA): ',
              clearable: true
            },
            {
              column: 16,
              type: 'elementInput',
              model: 'municipio.nome',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Municípios: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'municipio.codigoEstado',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 24,
              type: 'elementInput',
              model: 'portaria.areaPorExtenso',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Área por Extenso: ',
              clearable: true
            }
          ]
        },
        {
          legend: '5.1 - CONFRONTAÇÕES',
          codigo: 'CONFRONTACOES',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementTextArea',
              model: 'portaria.confrontantesFormatados',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Confrontantes: ',
              clearable: true
            }
          ]
        }
      ]
    },
    ONEROSO: {
      groups: [
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          styleClasses: 'none',
          fields: [
            {
              column: 12,
              type: 'elementInput',
              model: 'especie',
              inputName: 'especie',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Espécie: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'portaria.numeroSei',
              inputName: 'numeroSei',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº SEI: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: true,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementDatePicker',
              model: 'dataNascimentoOutorgado',
              inputName: 'dataNascimentoOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              editable: false,
              clearable: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Nascimento: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date',
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'profissao',
              inputName: 'profissao',
              visible: true,
              required: true,
              disabled: true,
              readonly: false,
              inputType: 'text',
              validator: 'required',
              elementLabel: 'Profissão: ',
              visiblePf: (model) => model.profissao,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: estadoCivil,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: orgaosExpedidores(),
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: (model) => model.orgaoExpedidorOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              visiblePf: (model) => model.ufRgOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: (model) => model.rgOutorgado,
              visiblePj: false
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: true,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 8,
              type: 'elementDatePicker',
              model: 'dataNascimentoConjuge',
              inputName: 'dataNascimentoConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              editable: false,
              clearable: true,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Nascimento: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: '
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: orgaosExpedidores(),
              filterable: false,
              elementLabel: 'Orgão expedidor: '
            }
          ]
        },
        {
          legend: '04 - FUNDAMENTAÇÃO ESTADUAL',
          codigo: 'FUNDAMENTACAO_ESTADUAL',
          styleClasses: 'none',
          fields: [
            {
              column: 12,
              type: 'elementInput',
              model: 'comarca',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              validator: 'required',
              elementLabel: 'Comarca: ',
              clearable: true
            }
          ]
        },
        {
          legend: '05 - CARACTERÍSTICAS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 8,
              type: 'elementInput',
              model: 'portaria.denominacao',
              inputName: 'input_name',
              visible: (model) => model.portaria.denominacao,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Denominação do Imóvel: ',
              clearable: true
            },
            {
              column: 16,
              type: 'elementInput',
              model: 'portaria.localizacao',
              inputName: 'input_name',
              visible: (model) => model.portaria.localizacao,
              disabled: true,
              required: true,
              readonly: false,
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Comunidade: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'portaria.areaLiquida',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Área (HA): ',
              clearable: true
            },
            {
              column: 16,
              type: 'elementInput',
              model: 'municipio.nome',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Municípios: ',
              clearable: true
            },
            {
              column: 8,
              type: 'elementInput',
              model: 'municipio.codigoEstado',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 24,
              type: 'elementInput',
              model: 'portaria.areaPorExtenso',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Área por Extenso: ',
              clearable: true
            }
          ]
        },
        {
          legend: '5.1 - CONFRONTAÇÕES',
          codigo: 'CONFRONTACOES',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementTextArea',
              model: 'portaria.confrontantesFormatados',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Confrontantes: ',
              clearable: true
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/analise/components/schemaTitulo/ba/schema.js